module.exports = __webpack_public_path__ + "img/FocussedEngaged.4c763f9c.png";